var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2311_28281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.0001C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24.0001",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6071 12.522C14.6071 9.02534 17.0645 6.10427 20.3462 5.38755C19.8418 5.27749 19.3186 5.21777 18.7809 5.21777C14.7467 5.21777 11.4766 8.48796 11.4766 12.5221C11.4766 16.5563 14.7467 19.8265 18.7809 19.8265C19.3184 19.8265 19.8417 19.7667 20.3462 19.6566C17.0645 18.9399 14.6071 16.0188 14.6071 12.522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 5.74023L24.5171 7.33445H26.1934L24.8371 8.31986L25.3552 9.91408L23.999 8.92886L22.6428 9.91408L23.1609 8.31986L21.8047 7.33445H23.4809L23.999 5.74023Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9328 8.86963L20.4507 10.4639H22.1271L20.7709 11.4493L21.289 13.0435L19.9328 12.0583L18.5764 13.0435L19.0946 11.4493L17.7383 10.4639H19.4146L19.9328 8.86963Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0654 8.86963L28.5836 10.4639H30.2598L28.9035 11.4493L29.4217 13.0435L28.0654 12.0583L26.7092 13.0435L27.2273 11.4493L25.8711 10.4639H27.5473L28.0654 8.86963Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5009 13.5669L27.019 15.1612H28.6953L27.3391 16.1465L27.8571 17.7407L26.5009 16.7555L25.1448 17.7407L25.6628 16.1465L24.3066 15.1612H25.9828L26.5009 13.5669Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4971 13.5669L22.0151 15.1612H23.6915L22.3353 16.1465L22.8534 17.7407L21.4971 16.7555L20.1409 17.7407L20.6589 16.1465L19.3027 15.1612H20.9791L21.4971 13.5669Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2311_28281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.f8225e2494ce848b1c636381cb8eacdd.svg";
export { ForwardRef as ReactComponent };